import '../css/Loader.css';

const Loader = () => {
  return (
    <div className="loader">
    <div className="loadingio-spinner-bean-eater-elz00pqdd3u"><div className="ldio-2mentkvc9re">
    <div><div></div><div></div><div></div></div><div><div></div><div></div><div></div></div>
    </div></div>
    </div>

  );
}

export default Loader;
